import { APIS, deleteApi, getApi, postApi } from "../utils/api-utils";

export const getConfiguredInceptionTenants = async (buildingId: string) => {
    return await getApi(APIS.INTEGRATION_API, `/inception/configured-tenants/${buildingId}`);
};

export const getAdminAccessDelegations = async (params: any) => {
    return await getApi(APIS.WALLET_API, "/admin/access-delegations", {
        queryStringParameters: params
    });
};

export const createAdminAccessDelegation = async (payload: any) => {
    return await postApi(APIS.WALLET_API, "/admin/access-delegations", payload);
};

export const revokeAdminAccessDelegation = async (delegation: any) => {
    return await deleteApi(
        APIS.WALLET_API,
        `/admin/access-delegations/${encodeURIComponent(delegation.buildingId)}/${encodeURIComponent(delegation.tenantId)}/${encodeURIComponent(delegation.ownerUserId)}/${encodeURIComponent(delegation.delegationId)}`
    );
};

export const reconcileAdminAccessDelegation = async (delegation: any) => {
    return await postApi(
        APIS.WALLET_API,
        `/admin/access-delegations/${encodeURIComponent(delegation.buildingId)}/${encodeURIComponent(delegation.tenantId)}/${encodeURIComponent(delegation.ownerUserId)}/${encodeURIComponent(delegation.delegationId)}/reconcile`,
        {}
    );
};

export const updateVisitorWalletPass = async (
    passId: string,
    action: "suspend" | "resume" | "revoke"
) => {
    return await postApi(APIS.WALLET_API, `/user/wallet/${action}`, {
        passId,
        reason: `ADMIN_VISITOR_${action.toUpperCase()}`
    });
};
